const Tracking = { 

	dataLayer:  window.dataLayer || [],

	resetEcommerce () { 
		this.dataLayer.push({
			ecommerce: null
		})
	},

	sendEvent(args) {
		this.dataLayer.push(args)
		this.resetEcommerce()
		console.log(this.dataLayer)
	 },

	setLieferUmfang (menge, plz, fahrzeug, schlauch) {
		this.sendEvent({		
			event: 'Lieferumfang',
			event_type: 'checkout_step1',
			ecommerce: {
				value: "",
				items: [
					{
						item_id: 'Undefined',
						item_name: 'Heizöl',
						liefermenge: menge,
						plz: plz,
						lieferfahrzeug: fahrzeug,
						schlauch: schlauch
					}
				]
			}
		})
	},

	setProduct (product, id, menge, value, plz, fahrzeug, schlauch) { 
		this.sendEvent({
			event: 'Heizoel waehlen',
			event_type: 'checkout_step2',
			ecommerce: {
				value: value,
				items: [
					{
						item_id: id,
						item_name: product,
						liefermenge: menge,
						plz: plz,
						lieferfahrzeug: fahrzeug,
						schlauch: schlauch
					}
				]
			}
		})
	},

	setPayment (product, payment, id, menge, value, plz, fahrzeug, schlauch) { 
		this.sendEvent({
			event: 'Bezahldetails',
			event_type: 'checkout_step3',
			ecommerce: {
				value: value,
				items: [
					{
						item_id: id,
						item_name: product,
						liefermenge: menge,
						plz: plz,
						lieferfahrzeug: fahrzeug,
						schlauch: schlauch,
						payment: payment
					}
				]
			}
		})
	},

	setPurchase (product, id, menge, value, plz, lieferfahrzeug, schlauch, payment) {
		// get date in milliseconds
		const date = new Date()
		const dateInMilliseconds = date.getTime()
		const transaction_id = dateInMilliseconds + '-' + id
		this.sendEvent({
			event: 'purchase',
			event_type: 'checkout_step4',
			ecommerce: {
				transaction_id: transaction_id,
				value: value,
				currency: "EUR",
				items: [
					{
						item_id: id,
						item_name: product,
						price: value,
						quantity: 1,
						plz: plz,
						lieferfahrzeug: lieferfahrzeug,
						schlauch: schlauch,
						payment: payment,
						weight_quantity: 1,
						liefermenge: menge,
					}
				]
			}
		})
	}

	
}

export default Tracking

// value
// items array
// item_id
// item_name
// liefermenge
// plz
// lieferfahrzeug
// schlauch
// payment
// transaction_id (genereieren)
// currency
// quantity
// weight quantity